'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.hoursSince;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/date/hoursSince.js
// module id = 506
// module chunks = 0